import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { UsableFieldType } from './usableFieldTypes';
import React from 'react';
import UsableFields from './UsableFields';

interface Props {
  canEdit: boolean;
}

const CustomListUsableFields = ({ canEdit }: Props) => {
  return (
    <>
      <Card body={false}>
        <Card.Header>
          <div className='title-s'>Usable fields</div>
          <a
            href='https://help.salv.com/en/articles/148040-custom-lists-screening#h_2e104b40e6'
            target='_blank'
            rel='noreferrer'
          >
            User manual
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='m-l-4' />
          </a>
        </Card.Header>
        <Card.Body>
          <div className={'m-b-16'}>
            Usable fields allow you to reference custom list values in screening and monitoring.
          </div>
          <UsableFields type={UsableFieldType.SCREENING} className={'m-b-16'} canEdit={canEdit} />
          <UsableFields type={UsableFieldType.MONITORING} canEdit={canEdit} />
        </Card.Body>
      </Card>
    </>
  );
};
export default CustomListUsableFields;
